import * as React from 'react';

/**
 * エラーメッセージの表示
 * @param props 
 * @returns 
 */
export const ErrorMessage = (props:{messages:string[]}) => {

    const display = (props.messages.length > 0) ? "" : "none";
    return (
        <div className="w-100 pt-2" style={{display:display}}>
            <ul className="error-message">
                {props.messages.map((item ,idx) => {
                    return(
                        <li>{item}</li>
                    );
                })}
            </ul>
        </div>
    );   
}